import { Routes } from '@angular/router';
import { AppAuthGuard, RoutingData, SemanticCode } from '@selfai-platform/shared';

export const aggregatorProccessRouting: Routes = [
  {
    path: 'aggregators',
    canActivate: [AppAuthGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../components/aggregator-process-list').then((m) => m.AggregatorProcessListComponentModule),
        pathMatch: 'full',
        data: { semanticCode: SemanticCode.AggregatorProcessList } as RoutingData,
      },
      {
        path: ':processUuid',
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadChildren: () =>
              import('../components/aggregator-route-list').then((m) => m.AggregatorRouteListComponentModule),
            data: { semanticCode: SemanticCode.AggregatorList } as RoutingData,
          },
          {
            path: ':uuid',
            loadChildren: () =>
              import('../components/aggregator-camel-editor').then((m) => m.AggregatorCamelEditorComponentModule),
            data: { semanticCode: SemanticCode.AggregatorEditor } as RoutingData,
          },
        ],
      },
    ],
  },
];
